<template>
  <md-content class="md-elevation-2 cta-content" @click="ctaClick()" data-cy="refer-cta">
    <div class="refer-cta">
      <div class="refer-img">
        <img src="/img/gift-points.svg" alt="Gift points"/>
      </div>
      <h4 class="refer-title">
        Refer friends and earn<br />
        up to 2500 points
        <br />
        <br />
      </h4>
      <span>Click here to learn more.</span>
    </div>
  </md-content>
</template>

<script>
export default {
  name: "ReferFriendsCTA",
  methods: {
    ctaClick() {
      this.$router.push("/s-app/invite-friends");
    },
  },
};
</script>

<style lang="scss" scoped>
.refer-cta {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 6px;
  height: 200px;
  cursor: pointer;
}
.refer-title {
  margin: 0.7em 0.2em 0.2em 0.2em;
  font-size: 18px;
  font-weight: bold;
  color: $black;
}
.cta-points-amount {
  color: $primary;
  margin: 0.4em;
}
.cta-content {
  width: 100%;
  max-width: 340px;
  min-width: 250px;
  border: 1px solid rgba(0, 0, 0, 0.12);
  box-sizing: border-box;
  border-radius: 4px;
}
</style>
